import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import KenDocumentUpload from '../KenDocumentUpload';
import { makeStyles } from '@mui/styles';
import { createDocuments, getDocumentByDocId } from '../../Utils/apiServices';
import { useSnackbar } from 'notistack';
import { saveAs } from 'file-saver';
import KenLoader from '../KenLoader';
import { TABLET_BREAKPOINT } from '../../Constants/constant';

const useStyles = makeStyles(() => ({
  title: {
    color: '#092682',
    fontWeight: 600,
    textAlign: 'left',
    marginBottom: 32,
    fontSize: 20,
  },
}));

export default function DocumentUpload(props) {
  const styles = useStyles();
  const { applicationState, applicationDispatch } = props;
  const [pageLoader, setPageLoader] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );

  const convertBase64ToFile = (base64String, fileName, fileType) => {
    let bstr = atob(base64String);
    let n = bstr.length;
    let uint8Array = new Uint8Array(n);
    while (n--) {
      uint8Array[n] = bstr.charCodeAt(n);
    }
    let file = new File([uint8Array], fileName, { type: fileType });
    return file;
  };

  const handleDownload = (id, fileType, fileName) => {
    setPageLoader(true);
    getDocumentByDocId(id)
      .then((res) => {
        if (res?.success && res?.data) {
          setPageLoader(false);
          let file = convertBase64ToFile(res?.data, fileName, fileType);
          saveAs(file, fileName);
        }
      })
      .catch((err) => {
        console.log(err);
        setPageLoader(false);
      });
  };

  const uploadDoc = (file, el) => {
    setPageLoader(true);
    const reader = new FileReader();
    let base64;
    reader.onloadend = () => {
      base64 = reader.result.replace('data:', '').replace(/^.+,/, '');
      const body = {
        fileName: `${applicationState?.applicationData?.application?.applicantId}_${file?.name}`,
        title: el?.documentType ? el?.documentType : el?.title,
        body: base64,
        documentChecklistId: el?.recordId,
        parentId: applicationState?.applicationData?.applicantId,
        mimeType: file.type,
        recordId: el?.recordId,
      };

      const requiredDocuments = applicationState?.documents?.filter((items) => {
        return items?.documentRequirement === 'Mandatory';
      });
      const submittedDocuments = applicationState?.documents?.filter(
        (items) => {
          return (
            items?.documentRequirement === 'Mandatory' &&
            items?.fileName !== null
          );
        }
      );

      let isEveryApplicationSubmitted = false;
      if (requiredDocuments.length === 1) {
        const getUploadingFile = applicationState.documents?.find((items) => {
          return items.recordId === el?.recordId;
        });
        if (getUploadingFile?.documentRequirement === 'Mandatory') {
          isEveryApplicationSubmitted = true;
        }
      } else {
        const getUploadingFile = applicationState.documents?.find((items) => {
          return items.recordId === el?.recordId;
        });
        if (getUploadingFile?.documentRequirement === 'Mandatory') {
          if (submittedDocuments.length + 1 === requiredDocuments.length) {
            isEveryApplicationSubmitted = true;
          }
        }
      }

      const payload = {
        attachments: [body],
        application: {
          ...applicationState?.applicationData?.application,
          currentStep: isEveryApplicationSubmitted
            ? `${
                applicationState?.activeStep <
                parseInt(applicationState?.totalSteps) - 1
                  ? applicationState?.activeStep + 1
                  : applicationState?.activeStep
              }`
            : parseInt(
                applicationState?.applicationData?.application?.currentStep
              ),
        },
      };

      createDocuments(payload)
        .then((res) => {
          setPageLoader(false);
          if (res?.success === true) {
            applicationDispatch({ type: 'triggerDocument' });
            return enqueueSnackbar('Document Uploaded Successfully', {
              variant: 'success',
            });
          }
        })
        .catch((err) => {
          setPageLoader(false);
          console.log('error', err);
          return enqueueSnackbar(
            'Error while uploading. Please try again later.',
            {
              variant: 'error',
            }
          );
        });
    };
    reader.readAsDataURL(file);
  };

  const { activeStep, totalSteps } = applicationState;
  const isLastStep = totalSteps - 1 === activeStep;

  return (
    <React.Fragment>
      {pageLoader && <KenLoader />}
      <Box
        sx={{
          width: isLastStep ? '100%' : isMobileScreen ? '80vw' : '50vw',
          margin: '0 auto',
          paddingBottom: 10,
        }}
      >
        {!isLastStep && (
          <Typography className={styles.title}>Document Upload</Typography>
        )}
        {applicationState?.documents?.map((el) => {
          const title = `Accepted formats are limited to ${
            ((el?.documentType ? el?.documentType : el?.title) || '')
              .toLowerCase()
              .includes('photo') ||
            ((el?.documentType ? el?.documentType : el?.title) || '')
              .toLowerCase()
              .includes('cheque') ||
            ((el?.documentType ? el?.documentType : el?.title) || '')
              .toLowerCase()
              .includes('passport')
              ? 'jpeg, jpg and png'
              : 'pdf'
          } with a maximum allowable file size of 2MB`;
          const label = el?.documentType ? el?.documentType : el?.title;
          const fileType =
            label === 'Cheque' ||
            label.toLowerCase().includes('photo') ||
            label.toLowerCase().includes('passport')
              ? 'image/*'
              : 'application/pdf';
          return (
            <>
              <KenDocumentUpload
                label={el?.documentType ? el?.documentType : el?.title}
                description={title}
                required={
                  el?.documentRequirement
                    ? el?.documentRequirement === 'Mandatory'
                    : false
                }
                handleDownload={handleDownload}
                onChange={(file) => uploadDoc(file[0], el)}
                {...el}
                fileType={fileType}
              />
              <Divider
                variant="fullWidth"
                style={{ background: '#E2E2E2', marginBottom: '30px' }}
              />
            </>
          );
        })}
      </Box>
    </React.Fragment>
  );
}
